import cleanedFilename from '~/util/cleanedFilename';

export default {
  REMOVE_BUTTON: `${cleanedFilename(__filename)}-remove-button`,
};
